module.exports = __webpack_public_path__ + "img/hero_textonly.e86b2208.png";